// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3D0ON","cell":"ColumnAccessor_cell__2NKBP","firstCellAccent":"ColumnAccessor_firstCellAccent__VZo0N"};